import { REQUIRED } from 'constants/errors';
import { isArray } from 'validate.js';
import { BaseCustomValidator } from '../types';

const requiredBaseValidator: BaseCustomValidator<any> = (validateModel, validate) => (
  value,
  options,
  key,
  attributes,
  globalOptions
) => {
  const { fields = [], checkFieldModel = false } = options;
  let areRequiredConditionsMet = true;

  fields.forEach((field) => { // eslint-disable-line consistent-return
    const target = value[field];

    if (typeof target === 'undefined') {
      areRequiredConditionsMet = false;
      return false;
    }
    if (isArray(target) && target.length === 0) {
      areRequiredConditionsMet = false;
      return false;
    }
    if (typeof target === 'string' && target === '') {
      areRequiredConditionsMet = false;
      return false;
    }

    if (typeof target === 'object' && Object.keys(target).length === 0) {
      areRequiredConditionsMet = false;
      return false;
    }

    if (typeof target === 'object' && checkFieldModel) {
      const keys = Object.keys(target);

      if (keys.includes('value')) {
        const childResult = requiredBaseValidator(validateModel, validate)(
          target,
          { fields: ['value'] },
          'value',
          attributes,
          globalOptions
        );

        if (childResult !== true) {
          areRequiredConditionsMet = false;
          return false;
        }
      }
    }
  });

  if (!areRequiredConditionsMet) {
    return REQUIRED;
  }

  return null;
};

export default requiredBaseValidator;
